/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { typography2 } from '@coursera/cds-core';

import FaqBaseComponent from 'bundles/design-system/components/Faq';

type FaqType = {
  question: string;
  answer: string;
};

export type PropsFromCaller = {
  faq: FaqType;
  index: number;
  component?: React.ElementType;
};

type PropsToComponent = PropsFromCaller;

const styles = {
  faqWrapper: () => css`
    max-width: 885px;

    .rc-Faq {
      svg {
        /* Important needed to override inline fill */
        fill: var(--cds-color-blue-700) !important;
      }

      .question {
        h3 {
          ${typography2.subtitleMedium}
          color: var(--cds-color-grey-975);
          padding: 0 10px;
        }
      }

      .answer {
        p {
          ${typography2.bodyPrimary}
          color: var(--cds-color-grey-975);

          a {
            color: var(--cds-color-blue-700);
          }
        }
      }
    }
  `,
  supportTextGrid: css`
    max-width: 747px;
  `,
};

const Faq: React.FC<PropsToComponent> = ({ faq, index, component }) => {
  return (
    <div className="faq-wrapper" css={styles.faqWrapper} data-e2e="article-page-faq">
      <FaqBaseComponent component={component} key={faq.question} faq={faq} index={index} />
    </div>
  );
};

export default Faq;
